import { render, staticRenderFns } from "./custom1.vue?vue&type=template&id=83e7bc94&scoped=true"
import script from "./custom1.vue?vue&type=script&lang=js"
export * from "./custom1.vue?vue&type=script&lang=js"
import style0 from "./custom1.vue?vue&type=style&index=0&id=83e7bc94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e7bc94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83e7bc94')) {
      api.createRecord('83e7bc94', component.options)
    } else {
      api.reload('83e7bc94', component.options)
    }
    module.hot.accept("./custom1.vue?vue&type=template&id=83e7bc94&scoped=true", function () {
      api.rerender('83e7bc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom1.vue"
export default component.exports